/**
 * Smooth scroll to an element or position on the page
 * 
 * @param {string|number} target - Element ID (with or without #) or Y position
 * @param {number} duration - Animation duration in milliseconds
 * @param {number} offset - Offset from the element in pixels
 */
export const scrollTo = (target, duration = 800, offset = 0) => {
    // Check if the browser supports smooth scrolling
    if (typeof window === 'undefined' || !('scrollBehavior' in document.documentElement.style)) {
      // Fallback for browsers that don't support smooth scrolling
      let targetPosition;
      
      if (typeof target === 'string') {
        // Handle string targets (element IDs)
        const targetElement = document.getElementById(target.replace('#', ''));
        if (!targetElement) return;
        
        targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
      } else if (typeof target === 'number') {
        // Handle numeric targets (Y positions)
        targetPosition = target;
      }
      
      window.scrollTo(0, targetPosition);
      return;
    }
    
    // Modern browsers supporting smooth scrolling
    try {
      if (typeof target === 'string') {
        const element = document.getElementById(target.replace('#', ''));
        if (!element) return;
        
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      } else if (typeof target === 'number') {
        window.scrollTo({
          top: target,
          behavior: 'smooth'
        });
      }
    } catch (error) {
      console.error('Error scrolling:', error);
    }
  };
  
  /**
   * Creates a scroll-to-top function
   * 
   * @param {number} duration - Animation duration in milliseconds
   * @returns {Function} Scroll to top function
   */
  export const scrollToTop = (duration = 800) => {
    return () => scrollTo(0, duration);
  };
  
  /**
   * Detect if an element is in the viewport
   * 
   * @param {HTMLElement} element - The element to check
   * @param {number} offset - Offset before element is considered in view
   * @returns {boolean} True if element is in viewport
   */
  export const isInViewport = (element, offset = 0) => {
    if (!element) return false;
    
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight - offset || document.documentElement.clientHeight - offset) &&
      rect.bottom >= offset &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth) &&
      rect.right >= 0
    );
  };